import { GROUPREPORTSTYPE } from "../definitions";

const initialState = {
  groupReportUserData: null,
  isGroupMemberAdded: null,
  needToCallAPI: false,
  error: null,
  newMemberAdded: null,
  deletedMember: null,
  memberNotUpdated: false,
};
const groupReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case GROUPREPORTSTYPE.GROUP_REPORT_FETCH: {
      return {
        ...state,
        groupReportUserData: null,
      };
    }
    case GROUPREPORTSTYPE.GROUP_REPORT_SUCCESS: {
      return {
        ...state,
        groupReportUserData: action.payload,
        error: null,
      };
    }
    case GROUPREPORTSTYPE.GROUP_REPORT_FAILED: {
      return {
        ...state,
        error: action.payload,
      };
    }

    case GROUPREPORTSTYPE.ADD_NEW_GROUP_MEMBER: {
      return {
        ...state,
        isGroupMemberAdded: null,
      };
    }
    case GROUPREPORTSTYPE.SUCCESS_NEW_GROUP_MEMBER: {
      return {
        ...state,
        isGroupMemberAdded: action.payload,
        error: null,
      };
    }
    case GROUPREPORTSTYPE.FAILED_NEW_GROUP_MEMBER: {
      return {
        ...state,
        isGroupMemberAdded: null,
        error: action.payload,
      };
    }
    case GROUPREPORTSTYPE.CHANGE_UPDATE_CALL: {
      return {
        ...state,
        needToCallAPI: action.payload,
      };
    }
    case GROUPREPORTSTYPE.ADDING_NEW_MEMBER: {
      return {
        ...state,
        newMemberAdded: action.payload,
      };
    }
    case GROUPREPORTSTYPE.DELETE_MEMBER: {
      return {
        ...state,
        deletedMember: null,
      };
    }
    case GROUPREPORTSTYPE.SUCCESS_DELETE_MEMBER: {
      return {
        ...state,
        deletedMember: action.payload,
      };
    }
    case GROUPREPORTSTYPE.FAILD_DELETE_MEMBER: {
      return {
        ...state,
        deletedMember: null,
        error: action.payload,
      };
    }
    case GROUPREPORTSTYPE.NEWMEMBER_NOT_ADDED: {
      return {
        ...state,
        memberNotUpdated: action.payload,
      };
    }
    default:
      return state;
  }
};

export { groupReportReducer };
